export const openMenu = 'openMenu'
export const closeMenu = 'closeMenu'
export const changeMenuBrand = 'changeMenuBrand'
export const SET_REHYDRATE = 'SET_REHYDRATE'
export const ADD_SNACKBAR = 'ADD_SNACKBAR'
